
import React, { Component } from 'react';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import './deviceDetailPage.less';
import PubSub from 'pubsub-js'
import btn_left from "../../../imgs/btn/btn_left.png";
import btn_right from "../../../imgs/btn/btn_right.png";
import ota from "../../../imgs/btn/ota.png";
import wifi from "../../../imgs/mesh/wifi_5.png";
import { SPGet, meshLog, SPSet } from '../../../utils/spUtils';
import { getNameBygroupID, getBleVer } from '../../../utils/meshUtils';
import { sendOpcode_device_ota} from '../../../utils/opcodeUtils';
import { DEVICE_ota_group, DEVICE_type_item, SPIN_DIALOG_HIDE, SPIN_DIALOG_SHOW } from '../../../const/infoConst';
import { getTypeName, judgeDiffItemData } from '../../../utils/deviceUtils';

let itemType=0; //Device type 0~3
let setGroups=[];
export default class DeviceDetailPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage:"1",
            totalPage:"1",
            list: [], //设备列表
        };
    }

    componentDidMount() {
        //类别分类
        PubSub.unsubscribe(DEVICE_type_item);
        PubSub.subscribe(DEVICE_type_item, (msg, index) => {
            meshLog("wjk Device type:", index);
            itemType=parseInt(index);
            this.goToPage(1);
        });
        //组分类
        PubSub.unsubscribe(DEVICE_ota_group);
        PubSub.subscribe(DEVICE_ota_group, (msg, index) => {
            meshLog("wjk Set groups:", index);
            setGroups=index;
            this.goToPage(1);
        });

        this.goToPage(1);

        //更新vid
        PubSub.subscribe("otaupdate", (msg, data) => {
            meshLog("更新vid", data);
            this.goToPage(1);
        });
    }

    //当前页数据
    goToPage(page){
        let arr=[];
        let count=0;
        let arrD = JSON.parse(SPGet("nodes"))
        for (let j = 0; j < arrD.length; j++) {
            if(judgeDiffItemData(arrD[j].pid, itemType)){
                let isAdd=false;
                for (let i = 0; i < setGroups.length; i++) {
                    if(setGroups[i].checked && setGroups[i].id==arrD[j].groupID){
                        isAdd=true;
                    }
                }
                //过滤选中组
                if(isAdd){
                    arr[count] = { 'id':count+1, 'mac':arrD[j].macAddress, 'pid':arrD[j].pid, 'name': arrD[j].name, 'type': getTypeName(itemType), 'ver': getBleVer(arrD[j].vid), 
                        'location': SPGet("SelectMeshName")+" / "+getNameBygroupID(arrD[j].groupID), 'status': 'On-line'};
                    count++;
                }
            }
        }
        meshLog("总数据:", arr);
        let arrP=[];
        let num=0;
        for (let i = 0; i < arr.length; i++) {
            if(i>=((page-1)*10) && i<(page*10)){
                arrP[num]=arr[i];
                num++
            }
        }
        //计算总页数
        let tt=1;
        if(arr.length%10==0){
            tt=parseInt(arr.length/10);
            if(tt<1)tt=1;
        }else{
            tt=parseInt((arr.length/10)+1);
        }

        this.setState({
            currentPage:page,
            totalPage:tt,
            list: arrP,
        });
    }

    //上一页
    goToPreviousPage(){
        let mm=parseInt(this.state.currentPage);
        mm--;
        if(mm<1)mm=1;
        meshLog("上一页:", mm);
        this.goToPage(mm);
    }
    //下一页
    goToNextPage(){
        let mm=parseInt(this.state.currentPage);
        let max=parseInt(this.state.totalPage);
        mm++;
        if(mm>max)mm=max;
        meshLog("下一页:", mm, max);
        this.goToPage(mm);
    }

    //刷新
    refreClick(){
        PubSub.publish(SPIN_DIALOG_SHOW, "");//加载框

        //10秒之后进行判断mqtt有没有收到信息
        setTimeout(() => {
            this.goToPage(1);
            PubSub.publish(SPIN_DIALOG_HIDE, "");
        }, 1500)

    }

    //多选框
    checkDevicesInfo = (key, item, value) => {
        meshLog('list', item);
    }

    //ota
    otaClick(mac){
        let arrD = JSON.parse(SPGet("nodes"))
        for (let j = 0; j < arrD.length; j++) {
            if(arrD[j].macAddress==mac){
                SPSet('controlDevice', JSON.stringify(arrD[j]));
                meshLog('ota mac', mac);
            }
        }
        sendOpcode_device_ota();
    };


    render() {
        const { currentPage,totalPage } = this.state;
        return (
            <div className="device_detail_container">
                {/* 归类 */}
                <div className='detail_top_info'>
                    <span className='i_1'>Single-device OTA</span>
                    <span className='i_2'  onClick={() => { this.refreClick() }}>Refresh</span>
                </div>

                {/* 列表标题 */}
                <div className='detail_title'>
                    <input className="t_checkbox" type='checkbox' name='group' value='' />
                    <span className='t_1'>No.</span>
                    <span className='t_2'>Device Name</span>
                    <span className='t_3'>Device Type</span>
                    <span className='t_4'>Upgrade Version</span>
                    <span className='t_5'>Device Location</span>
                    <span className='t_5'>Device Status</span>
                    <span className='t_6'>Device OTA</span>
                </div>
                {/* 列表 */}
                <div className="detail_list">
                    {this.state.list.map((item, key) => (
                        <div key={key} className="list_item">
                            <input className="l_checkbox" type='checkbox' name='group' value='' onChange={(e) => { this.checkDevicesInfo(key, item, e.target.value) }} />
                            <span className='l_1'>{item.id}</span>
                            <span className='l_2'>{item.name}</span>
                            <span className='l_3'>{item.type}</span>
                            <span className='l_4'>{item.ver}</span>
                            <span className='l_5'>{item.location}</span>
                            <img className='l_wifi' src={wifi} />
                            <span className='l_6'>{item.status}</span>
                            <img className='l_ota' src={ota} onClick={() => { this.otaClick(item.mac) }}/>
                        </div>
                    ))}
                </div>

                {/* 底部按钮 */}
                <div className="detail_footer">
                    <span className='info'>Total {totalPage} Pages</span>
                    <img className='btn_left' onClick={() => { this.goToPreviousPage() }} src={btn_left} />
                    <span className='page'>{currentPage}</span>
                    <img className='btn_right' onClick={() => { this.goToNextPage() }} src={btn_right} />
                </div>               


            </div>

        );
    }
}
